import React from 'react';
import SpamTracking from './spamTracking/spamTracking';

const FrontEndMonitoring = () => <SpamTracking />;

export default FrontEndMonitoring;
